
import React, { useState } from 'react';
import Logo from './Logo';
import { Menu, X } from 'lucide-react';

function Header() {
  const [isActive, setIsActive] = useState(false);

  const navItems = [
    { name: 'Solutions', href: '#solutions' },
    { name: 'Pricing', href: 'https://www.getmarter.com/pioneers' },
  ];

  return (
    <nav className="navbar is-white is-fixed-top has-shadow" role="navigation" aria-label="main navigation">
      <div className="container">
        <div className="navbar-brand">
          <a className="navbar-item" href="/">
            <Logo />
          </a>

          <a 
            role="button" 
            className={`navbar-burger ${isActive ? 'is-active' : ''}`}
            aria-label="menu" 
            aria-expanded={isActive ? "true" : "false"}
            onClick={() => setIsActive(!isActive)}
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div className={`navbar-menu ${isActive ? 'is-active' : ''}`}>
          <div className="navbar-end">
            {navItems.map((item) => (
              <a 
                key={item.name} 
                className="navbar-item has-text-marter-dark-gray" 
                href={item.href}
                onClick={() => setIsActive(false)}
              >
                {item.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Header;
